module.exports = __webpack_public_path__ + "static/lets2x-a89a10af7dfdbe81eb0551b07e0f816d.png";